export class MypageModel {
  public firstname: string;
  public lastname: string;
  public language: string;
  public gender: number;
  public addressRegionId: string;
  public defaultLanguage: string;
  public origin: string;
  public personalIdentifier: string;
  public sleep: string;
  public workExtent: string;

  constructor(data: any) {
    if (data) {
      this.firstname = data.firstname;
      this.lastname = data.lastname;
      this.language = data.language;
      this.gender = data.gender;
      this.personalIdentifier = data.personalIdentifier;
      this.addressRegionId = data.addressRegionId;
      this.sleep = data.sleep;
      this.workExtent = data.workExtent;
    }
  }
}
